export function isDiscordInviteUrl(url?: string | null): boolean {
  if (!url) return false
  return /(?:https?:\/\/)?(?:www\.)?(?:discord(?:app)?\.com\/invite|discord\.gg)\//i.test(url)
}

export function fieldValue(fields: { name?: string; value?: string }[] | null | undefined, name: string): string | null {
  if (!fields) return null
  const field = fields.find(item => item && item.name === name)
  return field && field.value != null ? String(field.value) : null
}



// WEBPACK FOOTER //
// ./src/components/Messages/Message/Embed/inviteUrl.ts